export default "__VITE_ASSET__HpieEtDX__"